import store from '@/store';
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import ActionTarget from '@/ts/ActionTarget';

@Module({name: 'Editor', namespaced: true})
export default class Editor extends VuexModule {
    public actionTargets: ActionTarget[] = [];
    public actionTargetsMap: { [index: number]: number } = {};

    @Mutation
    public RESET_EDITOR_STORE_STATE(): void {
        this.actionTargets    = [];
        this.actionTargetsMap = {};
    }

    get getActionTarget() {
        const targetCorporationIds = [store.state.Corporations.corporationId];
        const targetProjectIds = store.getters['Projects/selectedProjectIds'];
        const targetBuildingIds = store.getters['Buildings/selectedBuildingIds'];
        const targetPropertyIds = store.getters['Properties/selectedPropertyIds'];

        return new ActionTarget(
            targetCorporationIds,
            targetProjectIds,
            targetBuildingIds,
            targetPropertyIds,
        );
    }
}
